import { render, staticRenderFns } from "./waschepacket.vue?vue&type=template&id=2dfcc93c&"
import script from "./waschepacket.vue?vue&type=script&lang=js&"
export * from "./waschepacket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2dfcc93c')) {
      api.createRecord('2dfcc93c', component.options)
    } else {
      api.reload('2dfcc93c', component.options)
    }
    module.hot.accept("./waschepacket.vue?vue&type=template&id=2dfcc93c&", function () {
      api.rerender('2dfcc93c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2o2TaOdLCZXTj/JS/comp/waschepacket.vue"
export default component.exports